import React from 'react'
import TAPList from './TAPList'
import './TAP.css'
function TAP() {
  return (
    <div className='tap'>
      <TAPList/>
    </div>
  )
}

export default TAP

